export default function Select({
  label,
  name,
  options,
  value,
  onChange,
  className,
}) {
  return (
    <select
      className={`border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-gray-500 text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 ${className}`}
      placeholder={label}
      name={name}
      value={value}
      id={name}
      onChange={onChange}
    >
      {options.map(({ key, value, display }) => {
        return (
          <option key={key} value={value}>
            {display}
          </option>
        );
      })}
      {/* <option disabled value="empty">
        Ordernar por...
      </option>
      <option value="price asc">Precio ascendente</option>
      <option value="price desc">Precio descendente</option>
      <option value="km asc">Kilometraje ascendente</option>
      <option value="km desc">Kilometraje descendente</option>
      <option value="year asc">Año ascendente</option>
      <option value="year desc">Año descendente</option> */}
    </select>
  );
}
